import React from 'react'
import WelcomeMessage from './WelcomeMessage/welcomeMessage'
import DepartmentInfo from './DepartmentInfo/departmentInfo'
import Gallery from './Gallery/gallery'
import Contact from './Contact/contactUs'
import './Content.scss'
import { useCMSContext } from './../CMSContext'
import NewsAndAnnouncements from './NewsAndAnnouncements/NewsAndAnnouncements'
import MarketingSection from './MarketingSection/MarketingSection'
import CustomSection from './CustomSection/CustomSection'
import Alerts from './Alerts/Alerts'
import Donate from './Donate/Donate'
import Recruitment from './Recruitment/Recruitment'
import Notifications from './Notifications/Notifications'
import ResidentialPlans from './ResidentialPlans/ResidentialPlans'
import ResidentialPlansReport from "./ResidentialPlansReport/ResidentialPlansReport"
import TransactionsReport from "./TransactionsReport/TransactionsReport"
import PrepublishMembers from "./PrepublishMembers/PrepublishMembers";
import Resources from './Resources/resources'
import ErrorSnackBar from 'app/Components/Shared/ErrorSnackBar/ErrorSnackBar'
import { useErrorSnackBarContext } from 'app/Components/Shared/ErrorSnackBar/ErrorSnackBarContext'


const Content = ({
  section
}) => {
  //Interceptor.interceptor(useErrorModalContext().actions)
  const cmsContext = useCMSContext();
  const { fireDepartment, sectionTitle, sectionId, sectionOrder, isMarketing } = cmsContext.state
  const { errorSnackBarState, errorSnackBarActions } = useErrorSnackBarContext()
  
  return (
    <>
      <main>
      <ErrorSnackBar state={errorSnackBarState} actions={errorSnackBarActions} />
        {(() => {
          switch (section) {
            case 'home':
              return <WelcomeMessage fireDepartment={fireDepartment}></WelcomeMessage>
            case 'department-info':
              return <DepartmentInfo fireDepartment={fireDepartment}></DepartmentInfo>
            case 'gallery':
              return <Gallery fireDepartment={fireDepartment}></Gallery>
            case 'contact':
              return <Contact fireDepartment={fireDepartment}></Contact>
            case 'news':
              return <NewsAndAnnouncements fireDepartment={fireDepartment}></NewsAndAnnouncements>
            case 'customSection':
              return <CustomSection title={sectionTitle} id={sectionId} fireDepartment={fireDepartment} order={sectionOrder} isMarketing={isMarketing} ></CustomSection>
            case 'addMarketingCustom':
              return <MarketingSection></MarketingSection>
            case 'alerts':
              return <Alerts fireDepartment={fireDepartment}></Alerts>
            case 'donate':
              return <Donate fireDepartment={fireDepartment}></Donate>
            case 'recruitment':
              return <Recruitment fireDepartment={fireDepartment}></Recruitment>
            case 'notifications':
              return <Notifications fireDepartment={fireDepartment}></Notifications>
            case 'residentialplans':
              return <ResidentialPlans fireDepartment={fireDepartment}></ResidentialPlans>
            case 'residentialPlansReport':
              return <ResidentialPlansReport fireDepartment={fireDepartment}></ResidentialPlansReport>
            case 'transactionsReport':
              return <TransactionsReport fireDepartment={fireDepartment}></TransactionsReport>
            case 'Prepublish Members':
              return <PrepublishMembers fireDepartment={fireDepartment}></PrepublishMembers>
            case 'resources':
              return <Resources fireDepartment={fireDepartment}></Resources>
            default:
                return <CustomSection title={sectionTitle} id={sectionId} fireDepartment={fireDepartment} order={sectionOrder} isMarketing={isMarketing}></CustomSection>
          }
        })()}
      </main>
    </>
  )
}

export default Content
